<template>
  <div>
    <div class="pa-2 indigo">
      <span class="text-subtitle-1 font-weight-bold white--text"
        >これまでの生成履歴</span
      >
    </div>
    <div class="text-subtitle-2 pa-1 blue--text blue lighten-5">
      最大200件までの作成履歴を表示できます。
    </div>
    <v-card elevation="0">
      <v-card-title>
        <v-select
          v-model="limitCount"
          :items="[50, 100, 150, 200]"
          label="履歴取得件数"
          dense
          hide-details
          style="max-width: 120px"
        />
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="（キーワード検索）"
          single-line
          hide-details
          clearable
          dense
        ></v-text-field>
      </v-card-title>
      <!-- テーブル -->
      <v-data-table
        id="history-table"
        :headers="headers"
        :items="desserts"
        :search="search"
        item-key="id"
        :mobile-breakpoint="0"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [50, 100, 200, -1],
          'items-per-page-text': '表示件数',
        }"
      >
        <!-- eslint-disable-next-line -->
            <template v-slot:footer.page-text="props">
          {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
            props.itemsLength
          }}件
        </template>
        <!-- 画像 -->
        <!-- eslint-disable-next-line -->
      <template v-slot:item.image="{ item }">
          <v-avatar class="ma-1"
            ><v-img :src="setting.cdn + item.image"
          /></v-avatar>
        </template>
        <!-- 名前 -->
        <!-- eslint-disable-next-line -->
      <template v-slot:item.name="{ item }">
          {{ item.name }}
        </template>
        <!-- コメント -->
        <!-- eslint-disable-next-line -->
      <template v-slot:item.comment="{ item }">
          <div v-if="item.words" class="d-flex flex-row flex-wrap item-words">
            <span
              v-for="(word, index) in item.words"
              :key="index"
              class="px-2 py-1 ma-1 green lighten-6 rounded mini white--text font-bold"
              style="line-height: 1.2"
            >
              {{ word.replace(setting.text_input_label + "||", "") }}
            </span>
          </div>
          <div v-html="item.comment.replace(/\n/g, '<br>')"></div>
        </template>
        <!-- eslint-disable-next-line -->
      <template v-slot:item.copy="{ item }">
          <v-icon class="pa-1" @click="commentCopy(item)"
            >mdi-content-copy</v-icon
          >
        </template>
        <template v-slot:no-data> セラピストが登録されていません </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import { useRouter } from "@/utils";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import utilDate from "@/common/utilDate.js";
import utilFunc from "@/common/utilFunc.js";

export default defineComponent({
  props: ["shop_site_id"],
  setup(props, ctx) {
    const { router } = useRouter();
    const CastAiHistoriesRepository = repositoryFactory.get("castAiHistories");

    const state = reactive({
      limitCount: 50,
      search: "",
      headers: [
        {
          text: "生成時刻",
          value: "date_time",
          sortable: true,
          width: 160,
        },
        {
          text: "画像",
          value: "image",
          sortable: false,
          align: "center",
          class: "td_image",
          width: 80,
        },
        {
          text: "セラピスト名",
          value: "name",
          sortable: true,
          class: "td_name",
          width: 150,
        },
        {
          text: "タイプ",
          value: "comment_type",
          sortable: true,
          width: 120,
        },
        {
          text: "コメント",
          value: "comment",
          sortable: false,
          class: "td_comment",
        },
        {
          text: "コピー",
          value: "copy",
          sortable: false,
          align: "center",
          width: 80,
        },
      ],
      desserts: [], // DataTablesレコード格納用
    });

    // 初期化処理(同期処理)
    const init = async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // 店舗チェック falseの場合ログアウトになる
      const currentShop = store.getters["shops/currentShop"];
      if (!(await utilFunc.checkShop(currentShop.id, router))) return;

      // 更新結果取得
      state.desserts.splice(0);
      const params = {
        shop_id: store.getters["shops/currentShop"].id,
        limit: state.limitCount,
      };
      await CastAiHistoriesRepository.list(params)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              let objResponse = "";
              if (
                response.data[key].response !== null &&
                response.data[key].response !== ""
              ) {
                objResponse = JSON.parse(response.data[key].response);
              }
              const st = response.data[key].created_at.split("T");
              const words = [];
              if (
                response.data[key].prompt !== null &&
                response.data[key].prompt !== ""
              ) {
                const objPrompt = JSON.parse(response.data[key].prompt);
                const target_cast = objPrompt["target_cast"];
                Object.keys(target_cast).forEach(function (k) {
                  if (
                    k === "personality" ||
                    k === "specialty" ||
                    k === "hobbies" ||
                    k === "keywords"
                  ) {
                    if (target_cast[k] !== null && target_cast[k].length > 0) {
                      words.push(target_cast[k]);
                    }
                  }
                });
              }

              state.desserts.push({
                id: response.data[key].id,
                date_time:
                  st[0].replace(/-/g, "/") + " " + st[1].substring(0, 8),
                image: response.data[key].cast_image,
                name: response.data[key].cast_name,
                comment_type:
                  setting.comment_type_name[response.data[key].comment_type] ||
                  "",
                words: words,
                comment: objResponse["generated_comment"] || "",
              });
            });
          }
        })
        .catch((error) => {
          throw "ERROR:CastAiHistoriesRepository.list (" + error + ")";
        });

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    init();

    // limitCount変更時再取得
    watch(
      () => state.limitCount,
      async () => {
        await init();
      }
    );

    const commentCopy = async (item) => {
      try {
        await navigator.clipboard.writeText(item.comment);
        alert("コメントをクリップボードにコピーしました");
      } catch (e) {
        alert("クリップボードへのコピーに失敗しました");
      }
    };

    // 返却オブジェクト定義
    return {
      utilDate,
      setting,
      ...toRefs(state),
      init,
      commentCopy,
    };
  },
});
</script>
<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  padding: 6px 6px !important;
}
::v-deep .td_site_content_name {
  min-width: 150px;
  width: 250px;
}
::v-deep .td_site_name {
  min-width: 200px;
  width: 250px;
}
::v-deep .td_content_name {
  min-width: 80px;
  width: 120px;
}
::v-deep .td_comment {
  min-width: 250px;
}
</style>
